import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import StudentItem from './StudentItem';
import student from '../../assets/students.png';
import 'react-toastify/dist/ReactToastify.css';
import ShowLoading from '../helperComponent/ShowLoading';

toast.configure();

const StudentPage = () => {
  const [students, setStudents] = useState();
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(1);
  const [showLoading, setShowLoading] = useState(true);

  const uname = JSON.parse(localStorage.getItem('uname'));
  let fetchURL = `https://stucharge.bakersbrisk.com/api/studentsapi?username=${uname}&page=${page}`;
  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // fetch notes
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          if (
            response.data.length > 0 &&
            !response.data[response.data.length - 1].has_next
          )
            setNext(0);
          setStudents(response.data);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={student} alt='student' width='50' />
          <div className='main_greeting'>
            <h1>Students Details </h1>
            <p>Your active students are visible here</p>
            {showLoading && <ShowLoading />}
          </div>
        </div>
        {students && students.length ? (
          <>
            <div className='table-container'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Class Access</th>
                    <th>Courses</th>
                  </tr>
                </thead>
                <tbody>
                  <StudentItem students={students} />
                </tbody>
              </table>
            </div>
            <div className='change-page'>
              {page > 1 ? (
                <button
                  type='button'
                  onClick={() => setPage(page > 1 ? page - 1 : 1)}
                >
                  Prev
                </button>
              ) : null}
              {next === 1 ? (
                <button type='button' onClick={() => setPage(page + 1)}>
                  Next
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <div className='alert-heading'>
            <h1>No Student enrolled</h1>
          </div>
        )}
      </div>
    </main>
  );
};

export default StudentPage;
